import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const fmtEur = (n) => `€ ${(Number(n) || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
const SECTOR_LABEL = {
    efficienza_energetica: "Efficienza Energetica",
    noleggio_lungo_termine: "Noleggio LT",
    energy_quoter: "Energy Quoter",
};

export default function MyContracts() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/contracts")
            .then(({ data }) => setItems(data))
            .finally(() => setLoading(false));
    }, []);

    const earned = items.reduce((acc, c) => acc + (c.commission_paid_at ? (c.commission_amount || 0) : 0), 0);
    const expected = items.reduce((acc, c) => acc + (c.commission_expected || 0), 0);

    return (
        <div className="max-w-5xl mx-auto space-y-6" data-testid="my-contracts">
            <div>
                <div className="inline-flex items-center gap-2 bg-[#C7FF2C]/30 text-[#0C4650] px-3 py-1 rounded-full text-xs font-bold">
                    <Briefcase className="w-3 h-3" /> AREA AGENTE
                </div>
                <h1 className="mt-3 text-3xl sm:text-4xl font-black text-[#0C4650]">I miei contratti</h1>
                <p className="text-gray-600 mt-1 max-w-2xl">
                    Segui l'avanzamento delle tue pratiche confermate e il tuo compenso.
                </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
                <div className="card p-5">
                    <div className="text-[10px] tracking-widest font-bold text-[#898A8D]">PROVVIGIONE PREVISTA</div>
                    <div className="text-3xl font-black text-[#0C4650] mt-1">{fmtEur(expected)}</div>
                </div>
                <div className="card p-5 bg-gradient-to-br from-[#C7FF2C]/40 to-white">
                    <div className="text-[10px] tracking-widest font-bold text-[#0C4650]">PROVVIGIONE MATURATA</div>
                    <div className="text-3xl font-black text-[#0C4650] mt-1">{fmtEur(earned)}</div>
                </div>
            </div>

            {loading ? (
                <div className="card p-10 flex items-center justify-center">
                    <Loader2 className="w-6 h-6 animate-spin text-[#0C4650]" />
                </div>
            ) : items.length === 0 ? (
                <div className="card p-10 text-center text-gray-500" data-testid="no-my-contracts">
                    Nessun contratto attivo. I contratti nascono quando un cliente conferma la tua proposta.
                </div>
            ) : (
                <div className="space-y-3">
                    {items.map((c) => (
                        <Link key={c.id} to={`/contratti/${c.id}`}
                              className="card p-4 flex items-center justify-between hover:border-[#0C4650] transition-all block"
                              data-testid={`my-contract-${c.id}`}>
                            <div className="flex-1">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-black text-[#0C4650]">{c.client_name || "—"}</span>
                                    <span className="text-[10px] tracking-widest font-bold text-white bg-[#0C4650] px-2 py-0.5 rounded-full">
                                        {SECTOR_LABEL[c.sector] || c.sector}
                                    </span>
                                </div>
                                <div className="text-xs text-gray-500 mt-1">
                                    Fase: <b className="text-[#0C4650]">{c.current_stage_label}</b>
                                </div>
                            </div>
                            <div className="text-right shrink-0 ml-3">
                                <div className="font-black text-[#0C4650]">
                                    {fmtEur(c.commission_amount ?? c.commission_expected ?? 0)}
                                </div>
                                {c.commission_paid_at && (
                                    <div className="text-[10px] font-bold text-emerald-600">LIQUIDATA</div>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
